import { combineReducers } from "redux";
import {
  FETCH_ALL_EXHIBITORS,
  FETCH_EXHIBITORS,
  FETCH_ALL_PRODUCT_CATEGORY,
  FETCH_ALL_PRODUCT_INDUSTRY,
  FETCH_ALL_PRODUCT_SUB_CATEGORY,
  OPEN_EXHIBITOR_MODAL,
  DELETE_EXHIBITORS_SUCESS,
  DELETE_EXHIBITORS_ERROR,
  LOAD_EDIT_EXHIBITOR_DATA,
  UPDATED_EXHIBITOR_IMAGE,
  UPDATE_EXHIBITOR_FILES,
  EXHIBITOR_FILES_CHANGED,
  IMPORT_EXHIBITOR_MODAL,
  UPDATED_EXHIBITOR_BANNER,
  EXHIBITOR_WORKING_DYNAMIC_FORM,
  EXHIBITOR_COUNTING_NUMBERS,
} from "ActionsExhibitors";

export function AllExhibitorsReducers(state = [], action) {
  switch (action.type) {
    case FETCH_ALL_EXHIBITORS:
      return action.payload;
    default:
      return state;
  }
}

export function ExhibitorsReducers(state = [], action) {
  switch (action.type) {
    case FETCH_EXHIBITORS:
      return action.payload;
    default:
      return state;
  }
}

export function ProductCategories(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_CATEGORY:
      return action.payload;
    default:
      return state;
  }
}
export function ProductIndustries(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_INDUSTRY:
      return action.payload;
    default:
      return state;
  }
}

export function ProductSubCategories(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_SUB_CATEGORY:
      return action.payload;
    default:
      return state;
  }
}

export function openExhibitorPopup(state = [], action) {
  switch (action.type) {
    case OPEN_EXHIBITOR_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function loadEditExhibitorData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_EXHIBITOR_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function exhibitorImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATED_EXHIBITOR_IMAGE:
      return action.payload;
    default:
      return state;
  }
}

export function exhibitorBannerReducer(state = null, action) {
  switch (action.type) {
    case UPDATED_EXHIBITOR_BANNER:
      return action.payload;
    default:
      return state;
  }
}

export function exhibitorFilesList(
  state = [
    { position: "file1", file: "", filename: "" },
    { position: "file2", file: "", filename: "" },
    { position: "file3", file: "", filename: "" },
    { position: "file4", file: "", filename: "" },
    { position: "file5", file: "", filename: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_EXHIBITOR_FILES:
      return action.payload;
    default:
      return state;
  }
}

export function exhibitorFilesChanged(state = { ischanged: false }, action) {
  switch (action.type) {
    case EXHIBITOR_FILES_CHANGED:
      return action.payload;
    default:
      return state;
  }
}

export function importExhibitorModal(state = [], action) {
  switch (action.type) {
    case IMPORT_EXHIBITOR_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function exhibitorWorkingDynamicForm(state = null, action) {
  switch (action.type) {
    case EXHIBITOR_WORKING_DYNAMIC_FORM:
      return action.payload;
    default:
      return state;
  }
}

export function exhibitorsCount(state = {}, action) {
  switch (action.type) {
    case EXHIBITOR_COUNTING_NUMBERS:
      return action.payload;
    default:
      return state;
  }
}
